window.NCCSticky = (function() {
    'use strict';

    /**
     * NCCSticky
     *
     * Constructor
     *
     * @param element
     * @param options
     * @constructor
     */
    function NCCSticky(element, options) {
        // If element is a string, get the element, otherwise use the element
        this.element = typeof element === 'string' ? document.querySelector(element) : element;
        const defaultOptions = {
            offsetTop: 0,
            offsetBottom: 0
        };

        this.options = Object.assign({}, defaultOptions, options);

        for(let key in this.options) {
            this[key] = this.options[key];
        }

        // Duplicate element to create dummy node to fill space
        this.dummyNode = this.element.cloneNode(true);
        this.dummyNode.innerHTML = '';
        this.element.parentNode.insertBefore(this.dummyNode, this.element);
        this.dummyNode.classList.add('sticky-dummy');
        this.dummyNode.classList.remove('sticky');

        this.init();
    }

    NCCSticky.getOptions = function () {
        for(let key in NCCSticky.instance.options) {
            NCCSticky.instance[key] = NCCSticky.getOption(key);
        }
    }

    NCCSticky.getOption = function (option) {
        if (typeof NCCSticky.instance.options[option] === 'function') {
            return NCCSticky.instance.options[option]();
        }
        return NCCSticky.instance[option];
    }

    NCCSticky.instance = null;

    NCCSticky.prototype.init = function() {
        NCCSticky.instance = this;
        NCCSticky.getOptions();
        this.refresh();
    }

    NCCSticky.prototype.refresh = function () {
        NCCSticky.getOptions();

        // Get sticky element's distance from top
        const stickyTop = this.element.getBoundingClientRect().top;

        // get parent height
        const parentHeight = this.element.parentNode.offsetHeight;

        // Check if the sticky element has reached the bottom of the parent container so we can stop it from sticking
        let reachedBottom = window.pageYOffset >= (parentHeight - this.element.offsetHeight + this.offsetBottom + this.offsetTop);
        if(this.element.classList.contains('sticky--bottom')) {
            reachedBottom = window.pageYOffset >= (parentHeight - this.element.offsetHeight - this.offsetBottom);
        }

        if((window.pageYOffset + this.offsetTop) >= stickyTop && !reachedBottom) {
            // Make element sticky with offsetTop
            this.element.classList.add('sticky--stuck');
            this.element.style.top = this.offsetTop + 'px';
            this.dummyNode.style.display = 'block';
        } else {
            // Remove sticky class
            this.element.classList.remove('sticky--stuck');
            this.element.style.top = '';
            this.dummyNode.style.display = 'none';
        }

        // Check if the element is at the bottom of the page
        if(reachedBottom) {
            this.element.classList.add('sticky--bottom');
        } else {
            this.element.classList.remove('sticky--bottom');
        }
    }

    NCCSticky.scroll = function() {
        if(NCCSticky.instance) {
            NCCSticky.instance.refresh();
        }
    }

    window.addEventListener('scroll', NCCSticky.scroll);

    return NCCSticky;
})();